import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.36 6.144C3.018 3.88 5.45 2.33 8.191 2.33c2.74 0 5.173 1.55 5.83 3.814a.666.666 0 0 1-.64.853H3.002a.667.667 0 0 1-.64-.853m9.984-.48c-.756-1.152-2.288-2-4.153-2-1.866 0-3.397.848-4.153 2zM2.386 9.859a.67.67 0 0 1 .472-.196h10.666c.368 0 .667.299.667.667a3.333 3.333 0 0 1-3.333 3.333H5.524a3.333 3.333 0 0 1-3.333-3.333c0-.177.07-.346.195-.471m1.253 1.138a2 2 0 0 0 1.885 1.333h5.334a2 2 0 0 0 1.885-1.333z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M3.524 7.663a.667.667 0 0 0 0 1.334h9.334a.667.667 0 1 0 0-1.334z"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })